import React, { useEffect, useState } from 'react';
import './reviews.css';
import Nav from '../components/layout/nav';
import { supabase } from '../supabase';

const Reviews = () => {

    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    const [editingReview, setEditingReview] = useState(null);

    const [form, setForm] = useState({
        name: '',
        review: '',
        rating: ''
    });

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {

        setLoading(true);

        const { data: reviewsData, error: reviewsError } = await supabase
            .from('reviews')
            .select('*')
            .order('id', { ascending: false });

        const { data: summaryError } = await supabase
            .from('reviews_summary')
            .select('*');

        if (reviewsError) console.error(reviewsError);
        if (summaryError) console.error(summaryError);

        setReviews(reviewsData || []);
   

        setLoading(false);
    };
    const startEdit = (item) => {

        setEditingReview(item.id);

        setForm({
            name: item.name || '',
            review: item.review || '',
            rating: item.rating || ''
        });
    };

    const saveReview = async (id) => {

        const { error } = await supabase
            .from('reviews')
            .update({
                name: form.name,
                review: form.review,
                rating: form.rating
            })
            .eq('id', id);

        if (error) {
            alert(error.message);
            return;
        }

        setReviews(prev =>
            prev.map(item =>
                item.id === id
                    ? { ...item, ...form }
                    : item
            )
        );

        setEditingReview(null);
    };
    const deleteReview = async (id) => {

        const confirmDelete = window.confirm('Delete this review?');
        if (!confirmDelete) return;

        const { error } = await supabase
            .from('reviews')
            .delete()
            .eq('id', id);

        if (error) {
            alert(error.message);
            return;
        }

        setReviews(prev =>
            prev.filter(item => item.id !== id)
        );
    };

    return (
        <div className='dashboard'>

            <Nav />

            <div className='mainarea'>

                <div className='navtoppart'>

                    <div className='welcomebcakdiv'>
                        <h6 className='welcomebacktext'>Welcome back</h6>
                        <h6 className='admintitle'>Admin Dashboard</h6>
                    </div>

                    <div className='profileandnotidiv'>
                        <div className='notidiv'>
                            <div className='notiicon'></div>
                        </div>
                        <div className='profilediv'></div>
                    </div>

                </div>

                <div className='pagecenter'>

                    <div className='homecontainer'>

                        <section>

                            <div className='titlediv2'>
                                <div className='titlediv'>
                                    <h1>Reviews</h1>
                                    <h2>Manage reviews</h2>
                                </div>
                            </div>

                            {loading && (
                                <p className='loadingtext'>
                                    Loading...
                                </p>
                            )}

                            <div className='reviewsummarygrid'>

                                <div className='summarycard'>
                                    <h5>Total Reviews</h5>
                                    <h2>{reviews.length}</h2>
                                </div>

                                <div className='summarycard'>
                                    <h5>Average Rating</h5>
                                    <h2>
                                        {reviews.length > 0
                                            ? (
                                                reviews.reduce(
                                                    (acc, item) =>
                                                        acc + Number(item.rating),
                                                    0
                                                ) / reviews.length
                                            ).toFixed(1)
                                            : '0'}
                                    </h2>
                                </div>

                            </div>

                            <div className='reviewsgrid'>

                                {reviews.map((item) => (

                                    <div key={item.id} className='reviewcard'>

                                        {editingReview === item.id ? (

                                            <div className='reviewform'>

                                                <input
                                                    placeholder='Name'
                                                    value={form.name}
                                                    onChange={(e) =>
                                                        setForm({
                                                            ...form,
                                                            name: e.target.value
                                                        })
                                                    }
                                                />

                                                <textarea
                                                    placeholder='Review'
                                                    value={form.review}
                                                    onChange={(e) =>
                                                        setForm({
                                                            ...form,
                                                            review: e.target.value
                                                        })
                                                    }
                                                />

                                                <input
                                                    type='number'
                                                    placeholder='Rating'
                                                    value={form.rating}
                                                    onChange={(e) =>
                                                        setForm({
                                                            ...form,
                                                            rating: e.target.value
                                                        })
                                                    }
                                                />

                                                <div className='reviewactions'>
                                                    <button onClick={() => saveReview(item.id)}>
                                                        Save
                                                    </button>

                                                    <button onClick={() => setEditingReview(null)}>
                                                        Cancel
                                                    </button>
                                                </div>

                                            </div>

                                        ) : (

                                            <div className='reviewcontent'>

                                                <div className='reviewtop'>

                                                    <div className='reviewavatar'>
                                                        {item.name?.charAt(0).toUpperCase()}
                                                    </div>

                                                    <div>
                                                        <h3>{item.name}</h3>
                                                        <span>⭐ {item.rating}/5</span>
                                                    </div>

                                                </div>

                                                <p className='reviewtext'>
                                                    {item.text}
                                                </p>

                                                <div className='reviewactions'>
                                                    <button onClick={() => startEdit(item)}>
                                                        Edit
                                                    </button>

                                                    <button onClick={() => deleteReview(item.id)}>
                                                        Delete
                                                    </button>
                                                </div>

                                            </div>

                                        )}

                                    </div>

                                ))}

                            </div>

                        </section>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default Reviews;